import { createSlice } from '@reduxjs/toolkit';
import {
  _setCbpProvider,
  _setMonth,
  _setSearchCbp,
  _setStartingMonday,
} from './VerificationSliceActions';

const initialState = {
  newVerificationForm: false,
  cbpId: '',
  dateRcvd: '',
  dateSent: '',
  startingMonday: {
    id: '',
    value: '',
  },
  Month: {
    id: '',
    value: '',
  },
  provider: {
    cbpId: '',
    name: '',
  },
  searchCbp: '',
};

export const verificationListSlice = createSlice({
  name: 'verification',
  initialState,
  reducers: {
    newUpdateVerificationForm: (state, action) => action.payload,
    verificationsList: (state, action) => action.payload,
    setStartingMonday: _setStartingMonday,
    setMonth: _setMonth,
    setCbpProvider: _setCbpProvider,
    setSearchCbp: _setSearchCbp,
  },
});

export const {
  verificationsList,
  setStartingMonday,
  setMonth,
  setCbpProvider,
  newUpdateVerificationForm,
  setSearchCbp,
} = verificationListSlice.actions;

export default verificationListSlice.reducer;
